

import { useState } from "react";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";

type Tab = {
    label: string;
    content: React.ReactNode;
};

type TabsProps = {
    tabs: Tab[];
    contactUsPage?: { url: string; targetLink: LinkTargetProperties}
};


const CalcalistPaywallMyAccountTabs = ({tabs,contactUsPage}: TabsProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const contactUsPageUrl = contactUsPage && contactUsPage.url || 'https://www.calcalist.co.il/';
    return (
        <div className="CalcalistPaywallMyAccountTabs">
            <div role="tablist" className="tabs-header">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        role="tab"
                        aria-selected={activeIndex === index}
                        className={`tab-button ${activeIndex === index ? "active" : ""}`}
                        onClick={() => setActiveIndex(index)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div role="tabpanel" className="tabs-content">
                {tabs[activeIndex].content}
            </div>
            <div className="terms-text">
            <span>לביטול מינוי כלכליסט יש לשלוח שם מלא וטלפון באחד מהאופנים הבאים</span>: בווסטאפ 052-9995005, בפקס 03-6933999, בדואר: נח מוזס 1 
ת"ד 438 ראשון לציון 7510302, בכתובת מייל <a href="mailto:manuy@calcalist.co.il">manuy@calcalist.co.il</a>.  או באמצעות <a href={contactUsPageUrl}>טופס</a>, למעט לרוכשים באמצעות
                חנויות סלולר שאז הביטול דרך APPLE STORE ו-GOOGLE PLAY בהתאמה
            </div>
        </div>
    );
};

export default CalcalistPaywallMyAccountTabs